import React from 'react'
import type { RouteComponentProps } from 'react-router'
import { Route } from 'react-router'
import SearchUsers from './SearchUsers'
import EditUser from './EditUser'

export default function UsersIndex({ match }: RouteComponentProps) {
  return (
    <>
      <Route path={`${match.url}/`} exact component={SearchUsers} />
      <Route path={`${match.url}/:id/:section?`} component={EditUser} />
    </>
  )
}
